import {
  MenuOutlined,
  SyncOutlined,
} from "@ant-design/icons";

import type { CityLocation, DataFreshnessState, StormTrack } from "../domain/types";
import { CitySearch } from "./CitySearch";
import { DataFreshness } from "./DataFreshness";

interface HeaderBarProps {
  track: StormTrack;
  freshness: DataFreshnessState;
  selectedCity: CityLocation | null;
  onCitySearch: (query: string) => Promise<CityLocation[]>;
  onCitySelect: (city: CityLocation) => void;
  mobileNavigationOpen: boolean;
  onMobileNavigationToggle: () => void;
}

export function HeaderBar({
  track,
  freshness,
  selectedCity,
  onCitySearch,
  onCitySelect,
  mobileNavigationOpen,
  onMobileNavigationToggle,
}: HeaderBarProps) {
  const latest = track.observed.at(-1) ?? track.forecast[0];
  return (
    <div className="topbar glass-panel">
      <div className="topbar__identity">
        <button
          aria-controls="typhoon-navigation"
          aria-expanded={mobileNavigationOpen}
          aria-label={mobileNavigationOpen ? "关闭导航" : "打开导航"}
          className="topbar__mobile-menu icon-button"
          onClick={onMobileNavigationToggle}
          type="button"
        ><MenuOutlined /></button>
        <h1>风迹</h1>
        <span className="topbar__divider" />
        <strong>{track.identity.number} {track.identity.nameZh}</strong>
        <span className="topbar__intensity">{latest?.intensity ?? "强度待更新"}</span>
      </div>
      <div className="topbar__status">
        <DataFreshness compact state={freshness} updatedAt={track.updatedAt} />
        <span className="topbar__updated">更新 {formatShortTime(track.updatedAt)}</span>
        <span className="topbar__refresh"><SyncOutlined aria-hidden />自动刷新 5 分钟</span>
      </div>
      <div className="topbar__search">
        <CitySearch onSearch={onCitySearch} onSelect={onCitySelect} selectedCity={selectedCity} />
      </div>
    </div>
  );
}

function formatShortTime(time: string) {
  return new Intl.DateTimeFormat("zh-CN", {
    timeZone: "Asia/Shanghai",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    hour12: false,
  }).format(new Date(time));
}
